import { IStatesReducerState } from "modules/reducers/states";
import { createAction } from "redux-act";


export const fetchStatesJSON = createAction();
export const fetchStatesJSONSuccess = createAction<IStatesReducerState["items"]>();
export const fetchStatesJSONFailed = createAction<any>();
